import clsx from 'clsx';
import LoadingIcon from 'components/commercetools-ui/atoms/button/loadingIcon';
import Link from 'components/commercetools-ui/atoms/link';
import useMediaClipThumbnail from 'helpers/hooks/useMediaclipThumbnail';

type OrderItemsThumbnailImageProps = {
  item: any;
  idx?: string;
  lineItem?:any;
};

const OrderItemsThumbnailImage = ({ item, idx, lineItem }: OrderItemsThumbnailImageProps) => {
  let thumbnailItem = item;
  const mediaClipProjectId = item?.custom?.fields?.mediaClipProjectId;
  const { imageSrc, loading } = useMediaClipThumbnail(mediaClipProjectId);

  if (mediaClipProjectId) {
    thumbnailItem = {
      ...item,
      image: imageSrc,
      imageLoading: loading,
    };
  }

  const PRODUCT_IMAGE = 'w-full h-full rounded-lg object-contain ';

  return (
    <div className={clsx(`size-40 sm:w-64 sm:h-57 lg:w-98 lg:h-87 p-4 rounded-lg border border-[#EBEBEB]`)}>
      {thumbnailItem.imageLoading || !thumbnailItem.image ? (
        <div className="flex size-full flex-1 items-center justify-center text-[#333]">
          <LoadingIcon className="fill-gray-700" />
        </div>
      ) : (
          <Link
            title={lineItem?.name}
            link={lineItem?._url}
            data-ffid={`lnk-order-item-images-${idx}`}
          >
            <img
              src={thumbnailItem.image}
              alt={thumbnailItem.title}
              className={PRODUCT_IMAGE}
              data-ffid={`ctr-order-items-shiplist-image-${idx}`}
              loading="lazy"
            />
          </Link>
        
      )}
    </div>
  );
};

export default OrderItemsThumbnailImage;
